function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIconWrapper } from '../../components/atoms/Icon/withIconWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IconCloudUpload = function IconCloudUpload(props, ref) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none",
    ref: ref
  }, props), ___EmotionJSX("path", {
    d: "M18 11C18 7.2 14.8 4 11 4C7.8 4 5 6.2 4.2 9.2C1.8 9.8 0 11.8 0 14.4C0 17.4 2.4 20 5.6 20C7.4 20 15.8 20 17.6 20C20 20 22 18 22 15.4C22 13.2 20.2 11.2 18 11ZM12 13.4V15.4C12 16 11.6 16.4 11 16.4C10.4 16.4 10 16 10 15.4V13.4H8.2C7.8 13.4 7.6 12.8 7.8 12.6L10.6 9.8C10.8 9.6 11.2 9.6 11.4 9.8L14.2 12.6C14.6 13 14.2 13.4 13.8 13.4H12V13.4Z"
  }));
};

export default withIconWrapper( /*#__PURE__*/forwardRef(IconCloudUpload));
//# sourceMappingURL=IconCloudUpload.js.map